import React from "react";

// Icon file paths — existing PNGs from /images/icons/
const ICONS = {
  truck:    "/images/icons/icon-06.png",
  fire:     "/images/icons/icon-20.png",
  compass:  "/images/icons/icon-01.png",
  fishing:  "/images/icons/icon-25.png",
  toolbox:  "/images/icons/icon-28.png",
  mountain: "/images/icons/icon-02.png",
  backpack: "/images/icons/icon-10.png",
  tent:     "/images/icons/icon-07.png",
  axes:     "/images/icons/icon-09.png",
  gps:      "/images/icons/icon-27.png",
};

type IconDef = {
  src: string;
  left?: string;
  right?: string;
  top: string;
  size: number;
  delay: string;
};

const VARIANTS: Record<string, IconDef[]> = {
  hero: [
    { src: ICONS.truck,    left: "2%",  top: "12%", size: 52, delay: "icon-float-d1" },
    { src: ICONS.mountain, left: "3%",  top: "55%", size: 48, delay: "icon-float-d3" },
    { src: ICONS.fire,     left: "2%",  top: "80%", size: 44, delay: "icon-float-d5" },
    { src: ICONS.tent,     right: "2%", top: "10%", size: 52, delay: "icon-float-d2" },
    { src: ICONS.backpack, right: "3%", top: "45%", size: 48, delay: "icon-float-d4" },
    { src: ICONS.gps,      right: "2%", top: "75%", size: 44, delay: "icon-float-d6" },
  ],
  deals: [
    { src: ICONS.truck,    left: "2%",  top: "8%",  size: 50, delay: "icon-float-d2" },
    { src: ICONS.compass,  left: "3%",  top: "48%", size: 46, delay: "icon-float-d4" },
    { src: ICONS.toolbox,  left: "2%",  top: "82%", size: 44, delay: "icon-float-d6" },
    { src: ICONS.mountain, right: "2%", top: "15%", size: 50, delay: "icon-float-d1" },
    { src: ICONS.axes,     right: "3%", top: "55%", size: 46, delay: "icon-float-d3" },
    { src: ICONS.backpack, right: "2%", top: "80%", size: 44, delay: "icon-float-d5" },
  ],
  featured: [
    { src: ICONS.fire,     left: "2%",  top: "15%", size: 48, delay: "icon-float-d3" },
    { src: ICONS.fishing,  left: "3%",  top: "52%", size: 46, delay: "icon-float-d1" },
    { src: ICONS.gps,      left: "2%",  top: "80%", size: 44, delay: "icon-float-d5" },
    { src: ICONS.tent,     right: "2%", top: "20%", size: 48, delay: "icon-float-d2" },
    { src: ICONS.compass,  right: "3%", top: "58%", size: 46, delay: "icon-float-d4" },
    { src: ICONS.truck,    right: "2%", top: "78%", size: 44, delay: "icon-float-d6" },
  ],
  manufacturing: [
    { src: ICONS.axes,     left: "2%",  top: "10%", size: 50, delay: "icon-float-d4" },
    { src: ICONS.toolbox,  left: "3%",  top: "50%", size: 46, delay: "icon-float-d2" },
    { src: ICONS.truck,    left: "2%",  top: "82%", size: 44, delay: "icon-float-d6" },
    { src: ICONS.fire,     right: "2%", top: "18%", size: 50, delay: "icon-float-d1" },
    { src: ICONS.mountain, right: "3%", top: "52%", size: 46, delay: "icon-float-d3" },
    { src: ICONS.compass,  right: "2%", top: "80%", size: 44, delay: "icon-float-d5" },
  ],
  team: [
    { src: ICONS.backpack, left: "2%",  top: "14%", size: 48, delay: "icon-float-d5" },
    { src: ICONS.tent,     left: "3%",  top: "52%", size: 46, delay: "icon-float-d3" },
    { src: ICONS.gps,      left: "2%",  top: "80%", size: 44, delay: "icon-float-d1" },
    { src: ICONS.fishing,  right: "2%", top: "20%", size: 48, delay: "icon-float-d2" },
    { src: ICONS.axes,     right: "3%", top: "55%", size: 46, delay: "icon-float-d4" },
    { src: ICONS.fire,     right: "2%", top: "78%", size: 44, delay: "icon-float-d6" },
  ],
};

interface SectionBackgroundIconsProps {
  variant: "hero" | "deals" | "featured" | "manufacturing" | "team";
}

export function SectionBackgroundIcons({ variant }: SectionBackgroundIconsProps) {
  const icons = VARIANTS[variant] ?? [];

  return (
    <div
      className="absolute inset-0 pointer-events-none overflow-hidden hidden min-[375px]:block"
      style={{ zIndex: 0, opacity: 0.10 }}
      aria-hidden="true"
    >
      {icons.map((icon, i) => (
        <img
          key={i}
          src={icon.src}
          alt=""
          width={icon.size}
          height={icon.size}
          className={`absolute icon-float ${icon.delay}`}
          style={{
            left: icon.left,
            right: icon.right,
            top: icon.top,
            objectFit: "contain",
            filter: "brightness(1.5) saturate(0.7)",
          }}
        />
      ))}
    </div>
  );
}
